import React, { useState } from "react";
import {
  addRental,
  addSubs,
  addWallet,
  getRentHistory,
  getSubscriptionHistory,
  userWallet,
} from "../../utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Button,
  Drawer,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Table,
  Typography,
  message,
} from "antd";

const Subscription = ({
  row,

  subs,
}) => {
  const [visible, setVisible] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["subscription", row._id, visible],
    queryFn: async () => await getSubscriptionHistory(row._id),
    enabled: visible,
  });
  console.log(data);

  return (
    <div>
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        Subscription
      </Button>
      <Drawer
        title={"Subscription"}
        confirmLoading={isLoading}
        open={visible}
        onClose={() => setVisible(false)}
        footer={null}
        width={800}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 20,
          }}
        >
          <AddData refech={refetch} update={row} subs={subs} />
        </div>
        <Table
          dataSource={data}
          columns={[
            {
              title: "",
              render: (record) => record,
            },
          ]}
        />
      </Drawer>
    </div>
  );
};

export default Subscription;

const AddData = ({ refech, subs, update }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) => await addSubs(values),
    {
      onSuccess: () => {
        message.success(`Added`);
        //reset form
        form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        message.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button
        type="primary"
        onClick={() => setVisible(true)}
        style={{
          width: "100%",
        }}
      >
        Add
      </Button>
      <Modal
        title={"Add Wallet"}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 9 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          onFinish={(values) => {
            mutate({
              ...values,
              userId: update._id,
            });
          }}
        >
          {" "}
          <Form.Item label="Subscription" name="subscriptionId" required>
            <Select placeholder="Select">
              {subs?.map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
